import { Alert, AlertTitle, Typography } from '@mui/material'

const GLOSSARY_HELP_PAGE_URL =
  'https://docs.channel.io/kaminashireport/ja/categories/%E7%BF%BB%E8%A8%B3%E7%94%A8%E8%AA%9E%E9%9B%86%E8%A8%AD%E5%AE%9A-c7eec5a4'

export const GlossaryDescription = () => {
  return (
    <Alert severity="info" variant="outlined">
      <AlertTitle>この画面について</AlertTitle>
      <Typography variant="body2">
        翻訳時に、自動翻訳を適用させない専門用語や固有名詞を「用語集」として登録できます。詳しい使い方は、
        <a
          href={GLOSSARY_HELP_PAGE_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          ヘルプページ
        </a>
        をご確認ください。
      </Typography>
    </Alert>
  )
}
